import { ITEM_TYPES } from "../item/item-types";

export class EVENTS{
    static CheckEvents = "CheckEvents";
    static UpdateItems = "UpdateItems";
    static UpdateFriends= "getFriends";
    static UpdateMessages = "UpdateMessages";
    static UpdateCollections = "UpdateCollections";

}
export class EVENTS_Locally{
    static NewMessage = "NewMessage";
    static MessageRecevied = "MessageReceived";
    static DeliverMessage = "deliver";
    static Connected = "Connected";
    static tutorialAddCollection = "tutorialAddCollection";
    static updatedTitle = "updatedTitle";
    static platformReady = "platformReady";
    static SocketConnected = "socketConnected";
    static SocketDisconnected = "socketDisconnected";

}
export class PAGES {
static profile="profile";
static items="items";
static invite="invite";
static bayaPlus="bayaPlus";
static friends="friends";
static collections="collections";
static wallet="wallet";
static settings="settings";
static support="support";
  
}
export class SETTINGS {
    static notificationEnable="notificationEnable";
}
export class ACTIONS{
    static removeAllQuizMessages = "removeAllQuizMessages";
    static getSections = "getSections";
    static GetCollections = "getCollections";
    static GetExamples = "getExamples";
    static GetProposition = "getProposition";
    static GetItem = "getItem";
    static GetItems = "getItems";
    static GetSearchWords = "getSearchWords";
    static Unathorized = "unathorized";
    static Unkown = "unkown";
    static GetFriend = "getFriend";
    static GetMessage = "getMessage";
    static GetConjunction = "getConjunction";
    static DeleteEvent = "deleteEvent";
    static Translate = "translate";
    static getNewMessages = "getNewMessages";
    static getOlderMessage = "getOlderMessage";
    static getOlderScheduledMessage = "getOlderScheduledMessage";
    static getLatestMessage = "getLatestMessage";
    static resetPassword = "resetPassword";
    static login = "login";
    static getSuggestions = "getSuggestions";
    static addMessage = "addMessage";
    static addItem ="addItem";
    static removeItem = "removeItem";
    static removeMessage = "removeMessage";
    static UPDATE_MESSAGE= "updateMessage";
    static SolvedWordSearchGame = "solvedWordSearchGame";
    static updateSetting = "updateSetting";
    static AnswerICJ = "answerICJ";
    static SignUp= "signUp";
    static GenerateQuiz= "generateQuiz";
    static UPDATE_MESSAGE_BULK = "updateMessageBulk";
    static GET_MESSAGE_BY_ID = "getMessageByID";
    static GetLessonDetails = "getLessonDetails";
    static syncItems = "syncItems";
    static checkSubscription = "checkSubscription";
    static startPaypalSubscription = "startPaypalSubscription";
    static getSubscriptionStatus = "getSubscriptionStatus";
    static getSubscriptionPlans = "getSubscriptionPlans";
    static cancelSubscription = "cancelSubscription";
    static getActiveSubscriptionsByUserId = "getActiveSubscriptionsByUserId";
    static getOnlineUsers = "getOnlineUsers";
}
export class THEMES{
      static alieh =   "alieh-theme";
      static light =   "light-theme";
      static dark =   "dark-theme";
      static sparkasse =   "sparkasse-theme";
      static spring =   "spring-theme";
      static winter =   "winter-theme";
      static fallen =    "fallen-theme";
      static availableThemes : Array<String> = [THEMES.alieh, THEMES.light, THEMES.dark, THEMES.sparkasse, THEMES.spring, THEMES.winter, THEMES.fallen];

      construct(){
      }
      static getNextTheme(selectedTheme: String){
          let themeIndex = THEMES.availableThemes.indexOf(selectedTheme);
          if (themeIndex < THEMES.availableThemes.length-1  ){
              return THEMES.availableThemes[themeIndex+1];
          }
          else {
              return THEMES.availableThemes[0];
          }
      }
      
}
export class MESSAGE_ACTIONS {
    static Dictionary = "transl";
    static SendMsg = "sendChatMessage";
}



export class ICON_NAMES {
    static Dictionary = "list";
}

export class ACTIONS_Locally{
}

export class MESSAGE_STATUS {
    constructor() {
        
    }
    static created = "created";
    get created(): any {return this.created }
    static addedToChatPage = "addedToChatPage";
    get addedToChatPage(): any {return this.addedToChatPage }
    static pushedToServer = "pushedToServer";
    get pushedToServer(): any {return this.pushedToServer }
    static outOfDevice = "outOfDevice";
    get outOfDevice(): any {return this.outOfDevice }
    static receivedByServer = "receivedByServer";
    get receivedByServer(): any {return this.receivedByServer }
    static sentToUser = "sentToUser";
    get deliveredToUser(): any {return this.deliveredToUser }
    static deliveredToUser = "deliveredToUser";
    get seenByUser(): any {return this.seenByUser }
    static seenByUser = "seenByUser";
    get seenByAllUsers(): any {return this.seenByAllUsers }
    static seenByAllUsers = "seenByAllUsers";
    get seenByMe(): any {return this.seenByMe }
    static seenByMe = "seenByMe";
    get askedForOnlineContent(): any {return this.askedForOnlineContent }
    static askedForOnlineContent = "askedForOnlineContent";
    get downloadedContent(): any {return this.downloadedContent }
    static downloadedContent = "downloadedContent";
}
export class VALIDATION_ERROR {
    constructor() {
    }
    static verbFormatIsWorng = "VerbFormatIsWrong";
    get verbFormatIsWorng() {  return "VerbFormatIsWrong"};

    static nounHasNoArtikel = "NounHasNoArtikel";
        get nounHasNoArtikel() {  return "NounHasNoArtikel"};
    
    static translationInSameLanguage = "TranslationInSameLanguage";
        get translationInSameLanguage() {  return "TranslationInSameLanguage"};
        
    static wordTypeIsNotDefined = "WordTypeIsNotDefined";
        get wordTypeIsNotDefined() {  return "WordTypeIsNotDefined"};
        
    static translationHasBeenAlreadyAdded = "TranslationHasBeenAlreadyAdded";
        get translationHasBeenAlreadyAdded() {  return "TranslationHasBeenAlreadyAdded"};
}
export class WORD_TYPES {
    static noun = "noun";
        get noun() {  return "noun"};
    static verb = "verb";
        get adjective() {  return "adjective"};
    static adverb = "adverb";
        get adverb() {  return "adverb"};
    static adjective = "adjective";
        get combined() {  return "combined"};
    static undefined = "undefined";
        get undefined() {  return undefined};
}